/* YAET Heavy — theme.js (no dependencies) */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const Y = window.YAET || { routes: {}, strings: {}, cart: {} };

  /* ---------- helpers ---------- */
  function money(cents) {
    const fmt = (Y.money && Y.money.format) || '{{amount_with_comma_separator}} €';
    const v = (cents / 100);
    const withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const noDec = Math.round(v).toString();
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  }
  function toast(msg) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }
  function trapFocusOnce(panel) {
    const f = panel.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (f) f.focus({ preventScroll: true });
  }

  /* ---------- drawers ---------- */
  const Drawer = {
    open(id) {
      const d = document.getElementById(id); if (!d) return;
      $$('.drawer.is-open').forEach(o => { if (o !== d) Drawer.close(o.id); });
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      setTimeout(() => trapFocusOnce(d.querySelector('.drawer__panel')), 60);
      d.dispatchEvent(new CustomEvent('drawer:open'));
    },
    close(id) {
      const d = document.getElementById(id); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      if (!$('.drawer.is-open')) document.body.classList.remove('drawer-open');
    }
  };
  window.YAETDrawer = Drawer;
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); Drawer.open(o.dataset.drawerOpen); return; }
    const c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); Drawer.close(c.closest('.drawer').id); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(d => Drawer.close(d.id)); });

  /* ---------- header hide on scroll ---------- */
  (function () {
    const h = $('.header-wrap'); if (!h) return;
    let last = 0, ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y > 140 && y > last + 6) h.classList.add('is-hidden');
        else if (y < last - 6 || y < 140) h.classList.remove('is-hidden');
        last = y; ticking = false;
      });
    }, { passive: true });
  })();

  /* ---------- reveal ---------- */
  document.documentElement.classList.add('js');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
    setTimeout(() => $$('.reveal:not(.is-in)').forEach(el => el.classList.add('is-in')), 2500);
  } else { $$('.reveal').forEach(el => el.classList.add('is-in')); }

  /* ---------- cart ---------- */
  const Cart = {
    async add(items, opts = {}) {
      const res = await fetch(Y.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || err.message || Y.strings.error); }
      await Cart.refresh();
      if (Y.cart.drawer && !opts.silent) Drawer.open('CartDrawer'); else toast(Y.strings.added);
    },
    async change(line, quantity) {
      await fetch(Y.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      await Cart.refresh();
    },
    async refresh() {
      const [cartRes, secRes] = await Promise.all([
        fetch(Y.routes.cart + '.js').then(r => r.json()),
        fetch(Y.routes.cart + '?sections=cart-drawer').then(r => r.json())
      ]);
      $$('[data-cart-count]').forEach(el => { el.textContent = cartRes.item_count; el.dataset.count = cartRes.item_count; });
      const drawer = $('#CartDrawer');
      if (drawer && secRes['cart-drawer']) {
        const tmp = document.createElement('div'); tmp.innerHTML = secRes['cart-drawer'];
        const fresh = tmp.querySelector('#CartDrawer .drawer__panel');
        const cur = drawer.querySelector('.drawer__panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartRes }));
      return cartRes;
    }
  };
  window.YAETCart = Cart;

  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const line = q.closest('[data-line]').dataset.line;
      const input = q.parentElement.querySelector('input');
      let v = parseInt(input.value, 10) + parseInt(q.dataset.qtyChange, 10);
      if (v < 0) v = 0; input.value = v;
      q.closest('.cart-line').style.opacity = .5;
      await Cart.change(line, v);
      return;
    }
    const r = e.target.closest('[data-remove-line]');
    if (r) { e.preventDefault(); r.closest('.cart-line').style.opacity = .5; await Cart.change(r.dataset.removeLine, 0); return; }
    const u = e.target.closest('[data-upsell-add]');
    if (u) { e.preventDefault(); u.classList.add('is-loading'); try { await Cart.add([{ id: parseInt(u.dataset.upsellAdd, 10), quantity: 1 }], { silent: true }); toast(Y.strings.added); } catch (err) { toast(err.message); } u.classList.remove('is-loading'); }
  });
  document.addEventListener('change', async e => {
    const input = e.target.closest('.qty input'); if (!input) return;
    const line = input.closest('[data-line]').dataset.line;
    await Cart.change(line, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- product form ---------- */
  class ProductForm {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse(root.querySelector('[data-product-json]').textContent);
      this.optColor = this.data.options.findIndex(o => /farbe|colou?r/i.test(o));
      this.optSize = this.data.options.findIndex(o => /größe|groesse|size/i.test(o));
      this.state = { color: root.dataset.initialColor || null, size: null };
      this.gallery = $('[data-gallery]', root.closest('.pdp') || document);
      this.idInput = root.querySelector('input[name="id"]');
      this.btn = root.querySelector('[data-atc]');
      this.priceEl = root.querySelector('[data-price]');
      this.stockEl = root.querySelector('[data-stock]');
      this.sizeBtns = $$('[data-size]', root);
      this.swatches = $$('[data-color]', root);
      this.sticky = $('[data-sticky-atc]');
      this.bind();
      // preselect variant from URL
      const params = new URLSearchParams(location.search);
      const vid = parseInt(params.get('variant'), 10);
      if (vid) { const v = this.data.variants.find(x => x.id === vid); if (v) { this.state.color = v.options[this.optColor]; this.state.size = v.options[this.optSize]; } }
      const farbe = params.get('Farbe') || params.get('farbe');
      if (!this.state.color && farbe && this.optColor > -1 && this.data.variants.some(x => x.options[this.optColor] === farbe)) this.state.color = farbe;
      if (!this.state.color && this.optColor > -1) this.state.color = this.data.variants[0].options[this.optColor];
      this.render();
    }
    bind() {
      this.swatches.forEach(s => s.addEventListener('click', e => { e.preventDefault(); this.state.color = s.dataset.color; this.render(); }));
      this.sizeBtns.forEach(b => b.addEventListener('click', e => { e.preventDefault(); this.state.size = b.dataset.size; this.render(); }));
      this.root.addEventListener('submit', e => this.submit(e));
      if (this.sticky) {
        const stickyBtn = this.sticky.querySelector('[data-sticky-btn]');
        stickyBtn && stickyBtn.addEventListener('click', () => {
          if (!this.state.size) { this.root.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          this.root.requestSubmit();
        });
        if ('IntersectionObserver' in window && this.btn) {
          new IntersectionObserver(es => es.forEach(en => this.sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0))).observe(this.btn);
        }
      }
    }
    variant() {
      return this.data.variants.find(v =>
        (this.optColor === -1 || v.options[this.optColor] === this.state.color) &&
        (this.optSize === -1 || v.options[this.optSize] === this.state.size)
      );
    }
    colorVariants() { return this.data.variants.filter(v => this.optColor === -1 || v.options[this.optColor] === this.state.color); }
    render() {
      const v = this.variant();
      // swatches
      this.swatches.forEach(s => s.classList.toggle('is-active', s.dataset.color === this.state.color));
      const colorLabel = this.root.querySelector('[data-color-label]'); if (colorLabel) colorLabel.textContent = this.state.color || '';
      // sizes availability
      const cv = this.colorVariants();
      this.sizeBtns.forEach(b => {
        const sv = cv.find(x => x.options[this.optSize] === b.dataset.size);
        b.classList.toggle('is-soldout', !(sv && sv.available));
        b.classList.toggle('is-active', b.dataset.size === this.state.size);
        b.setAttribute('aria-pressed', b.dataset.size === this.state.size);
      });
      // gallery
      if (this.gallery && this.state.color) {
        const items = $$('.gallery__item', this.gallery);
        let shown = 0;
        items.forEach(it => { const match = !it.dataset.color || it.dataset.color === this.state.color; it.hidden = !match; if (match) shown++; });
        const total = this.gallery.querySelector('[data-gallery-total]'); if (total) total.textContent = shown;
        const track = this.gallery.querySelector('.gallery__track'); if (track) track.scrollTo({ left: 0 });
      }
      // price
      const priceSrc = v || cv[0] || this.data.variants[0];
      if (this.priceEl && priceSrc) {
        let html = '';
        if (priceSrc.compare_at_price && priceSrc.compare_at_price > priceSrc.price) html = `<span class="sale">${money(priceSrc.price)}</span><s>${money(priceSrc.compare_at_price)}</s>`;
        else html = `<span>${money(priceSrc.price)}</span>`;
        this.priceEl.innerHTML = html;
      }
      // button + stock + id + url
      if (this.btn) {
        this.btn.disabled = false;
        if (!this.state.size && this.optSize > -1) { this.btn.textContent = Y.strings.chooseSize; }
        else if (!v) { this.btn.textContent = Y.strings.unavailable; this.btn.disabled = true; }
        else if (!v.available) { this.btn.textContent = Y.strings.soldOut; this.btn.disabled = true; }
        else this.btn.textContent = Y.strings.addToCart;
      }
      if (v) {
        this.idInput.value = v.id;
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      if (this.stockEl) {
        this.stockEl.className = 'stock';
        if (!v) { this.stockEl.textContent = this.stockEl.dataset.inStock; }
        else if (!v.available) { this.stockEl.classList.add('is-out'); this.stockEl.textContent = Y.strings.soldOut; }
        else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) { this.stockEl.classList.add('is-low'); this.stockEl.textContent = this.stockEl.dataset.lowStock.replace('__count__', v.inventory_quantity); }
        else this.stockEl.textContent = this.stockEl.dataset.inStock;
      }
      const notify = this.root.querySelector('[data-notify]'); if (notify) notify.hidden = !(v && !v.available);
      // sticky
      if (this.sticky) {
        const p = this.sticky.querySelector('[data-sticky-price]'); if (p && priceSrc) p.textContent = money(priceSrc.price);
        const s = this.sticky.querySelector('[data-sticky-variant]'); if (s) s.textContent = [this.state.color, this.state.size].filter(Boolean).join(' · ');
        const b = this.sticky.querySelector('[data-sticky-btn]'); if (b) b.textContent = this.state.size ? (v && v.available ? Y.strings.addToCart : Y.strings.soldOut) : Y.strings.chooseSize;
      }
      // complete the look: sync color
      document.dispatchEvent(new CustomEvent('product:color', { detail: { color: this.state.color } }));
      // size chart highlight
      $$('.size-chart tr[data-size]').forEach(tr => tr.classList.toggle('is-highlight', tr.dataset.size === this.state.size));
    }
    async submit(e) {
      e.preventDefault();
      if (this.optSize > -1 && !this.state.size) { const sz = this.root.querySelector('.sizes'); sz && sz.scrollIntoView({ behavior: 'smooth', block: 'center' }); toast(Y.strings.chooseSize); return; }
      const v = this.variant(); if (!v || !v.available) return;
      this.btn.classList.add('is-loading');
      try { await Cart.add([{ id: v.id, quantity: 1 }]); }
      catch (err) { toast(err.message); }
      this.btn.classList.remove('is-loading');
    }
  }
  $$('[data-product-form]').forEach(f => { f._pf = new ProductForm(f); });

  /* ---------- complete the look ---------- */
  $$('[data-ctl]').forEach(box => {
    const items = $$('[data-ctl-item]', box);
    const main = $('[data-product-form]');
    const total = box.querySelector('[data-ctl-total]');
    const btn = box.querySelector('[data-ctl-add]');
    function itemVariant(it) {
      const d = JSON.parse(it.querySelector('script').textContent);
      const color = it.dataset.color; const size = it.querySelector('select').value;
      const ci = d.options.findIndex(o => /farbe|colou?r/i.test(o)), si = d.options.findIndex(o => /größe|size/i.test(o));
      return d.variants.find(v => (ci === -1 || v.options[ci] === color) && (si === -1 || v.options[si] === size));
    }
    const regular = box.querySelector('[data-ctl-regular]');
    const note = box.querySelector('[data-ctl-note]');
    function setPct(count) {
      const c = Y.cart || {};
      if (c.set2MinQty && count >= c.set2MinQty) return c.set2Percent || 0;
      if (c.setMinQty && count >= c.setMinQty) return c.setPercent || 0;
      return 0;
    }
    function sync(color) {
      let sum = 0, count = 0;
      if (main && main._pf) { const mv = main._pf.variant() || main._pf.colorVariants()[0]; if (mv) { sum += mv.price; count++; } }
      items.forEach(it => {
        const d = JSON.parse(it.querySelector('script').textContent);
        const ci = d.options.findIndex(o => /farbe|colou?r/i.test(o));
        const has = ci === -1 || d.variants.some(v => v.options[ci] === color);
        it.dataset.color = has ? color : d.variants[0].options[ci];
        const media = d.media_by_color && d.media_by_color[it.dataset.color];
        const img = it.querySelector('img'); if (img && media) img.src = media;
        const chk = it.querySelector('input[type=checkbox]');
        const v = itemVariant(it);
        it.querySelector('.price').textContent = v ? money(v.price) : '';
        it.querySelector('select').disabled = !v;
        if (chk && chk.checked && v && v.available) { sum += v.price; count++; }
      });
      const pct = setPct(count);
      const setPrice = Math.round(sum * (100 - pct) / 100);
      if (total) total.textContent = money(setPrice);
      if (regular) regular.textContent = pct ? money(sum) : '';
      if (note) note.textContent = pct ? `–${pct} % Set-Rabatt, wird im Warenkorb abgezogen (du sparst ${money(sum - setPrice)})` : 'Rabatt wird im Warenkorb abgezogen';
    }
    document.addEventListener('product:color', e => sync(e.detail.color));
    box.addEventListener('change', () => sync(main && main._pf ? main._pf.state.color : items[0].dataset.color));
    btn && btn.addEventListener('click', async () => {
      const list = [];
      if (main && main._pf) {
        if (!main._pf.state.size) { toast(Y.strings.chooseSize); main.querySelector('.sizes').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        const mv = main._pf.variant(); if (mv && mv.available) list.push({ id: mv.id, quantity: 1 });
      }
      items.forEach(it => { const chk = it.querySelector('input[type=checkbox]'); const v = itemVariant(it); if (chk.checked && v && v.available) list.push({ id: v.id, quantity: 1 }); });
      if (!list.length) return;
      btn.classList.add('is-loading');
      try { await Cart.add(list); } catch (err) { toast(err.message); }
      btn.classList.remove('is-loading');
    });
    sync(main && main._pf ? main._pf.state.color : (items[0] && items[0].dataset.color));
  });

  /* ---------- quick add on cards ---------- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); b.classList.add('is-loading');
    try { await Cart.add([{ id: parseInt(b.dataset.quickAdd, 10), quantity: 1 }]); } catch (err) { toast(err.message); }
    b.classList.remove('is-loading');
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quick-toggle]'); if (!b) return;
    e.preventDefault(); const q = b.closest('.card').querySelector('.card__quick'); if (q) q.style.display = q.style.display === 'block' ? '' : 'block';
  });

  /* ---------- gallery counter (mobile) ---------- */
  $$('[data-gallery]').forEach(g => {
    const track = g.querySelector('.gallery__track'); const cur = g.querySelector('[data-gallery-current]'); if (!track || !cur) return;
    track.addEventListener('scroll', () => {
      const items = $$('.gallery__item:not([hidden])', track); const w = items[0] ? items[0].offsetWidth + 4 : 1;
      cur.textContent = Math.min(items.length, Math.round(track.scrollLeft / w) + 1);
    }, { passive: true });
  });

  /* ---------- predictive search ---------- */
  $$('[data-predictive]').forEach(form => {
    const input = form.querySelector('input[type=search]'); const out = form.parentElement.querySelector('[data-predictive-results]'); let t;
    input.addEventListener('input', () => {
      clearTimeout(t); const q = input.value.trim(); if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        const r = await fetch(`${Y.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
        const html = await r.text(); const tmp = document.createElement('div'); tmp.innerHTML = html;
        out.innerHTML = tmp.querySelector('#shopify-section-predictive-search') ? tmp.querySelector('#shopify-section-predictive-search').innerHTML : html;
      }, 220);
    });
  });

  /* ---------- collection sort ---------- */
  const sortSel = $('[data-sort]');
  sortSel && sortSel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u; });
  $$('[data-filter-form]').forEach(f => f.addEventListener('change', () => { f.requestSubmit ? f.requestSubmit() : f.submit(); }));

  /* ---------- size chart tabs ---------- */
  $$('[data-tabs]').forEach(w => {
    const btns = $$('[data-tab]', w), panes = $$('[data-pane]', w);
    btns.forEach(b => b.addEventListener('click', () => { btns.forEach(x => x.classList.toggle('is-active', x === b)); panes.forEach(p => p.hidden = p.dataset.pane !== b.dataset.tab); }));
  });

  /* ---------- back in stock (mailto fallback) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-notify-submit]'); if (!b) return;
    const f = b.closest('[data-notify-form]'); if (!f) return;
    e.preventDefault(); const email = f.querySelector('input').value; if (!email) return; const subj = encodeURIComponent('Benachrichtigung: ' + f.dataset.product);
    location.href = `mailto:${f.dataset.email}?subject=${subj}&body=${encodeURIComponent('Bitte informiert mich, wenn ' + f.dataset.product + ' wieder verfügbar ist. E-Mail: ' + email)}`;
    toast('Danke – wir melden uns.');
  });


  /* ---------- UGC reel: shuffle + autoplay only when visible ---------- */
  $$('[data-ugc-track]').forEach(track => {
    if (track.hasAttribute('data-ugc-shuffle')) {
      const items = Array.from(track.children);
      for (let i = items.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [items[i], items[j]] = [items[j], items[i]]; }
      items.forEach(el => track.appendChild(el));
    }
    const vids = $$('[data-ugc-video]', track);
    const play = v => { if (v.dataset.loaded !== '1') { v.dataset.loaded = '1'; v.load(); } const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(en => { en.isIntersecting ? play(en.target) : en.target.pause(); }), { rootMargin: '200px 0px', threshold: 0.15 });
      vids.forEach(v => io.observe(v));
    } else { vids.forEach(play); }
  });


  /* ---------- set builder ---------- */
  $$('[data-set-builder]').forEach(root => {
    const dataEl = root.querySelector('[data-sb-products]'); if (!dataEl) return;
    let products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const icons = {};
    $$('[data-sb-icons] template', root).forEach(t => { icons[t.dataset.icon] = t.innerHTML; });
    const icon = k => icons[k] || '';
    const TYPE_ORDER = ['hoodie', 'zip-hoodie', 't-shirt', 'jogger-cuffed', 'jogger-open-leg'];
    const c = Y.cart || {};
    const tiers = [[c.set2MinQty || 3, c.set2Percent || 20], [c.setMinQty || 2, c.setPercent || 10]];
    const pctFor = n => { for (const [q, p] of tiers) if (n >= q) return p; return 0; };

    const defaults = (root.dataset.defaultTypes || 'hoodie,t-shirt,jogger-cuffed').split(',').map(x => x.trim()).filter(Boolean);
    const state = {
      gender: 'herren',
      color: root.dataset.defaultColor || null,
      size: root.dataset.defaultSize || null,
      slots: defaults.slice(0, 4).map(t => ({ type: t, color: null, size: null }))
    };
    const el = {
      gender: root.querySelector('[data-sb-gender]'), colors: root.querySelector('[data-sb-colors]'), colorLabel: root.querySelector('[data-sb-color-label]'),
      sizes: root.querySelector('[data-sb-sizes]'), slots: root.querySelector('[data-sb-slots]'), addSlot: root.querySelector('[data-sb-add-slot]'),
      list: root.querySelector('[data-sb-list]'), regular: root.querySelector('[data-sb-regular]'), pct: root.querySelector('[data-sb-pct]'),
      saving: root.querySelector('[data-sb-saving]'), total: root.querySelector('[data-sb-total]'), note: root.querySelector('[data-sb-note]'), carts: $$('[data-sb-cart]', root), summary: root.querySelector('[data-sb-summary]'), sticky: root.querySelector('[data-sb-sticky]'), total2: root.querySelector('[data-sb-total-2]'), note2: root.querySelector('[data-sb-note-2]')
    };

    const forGender = () => products.filter(p => !p.gender || p.gender === state.gender);
    const byType = t => forGender().find(p => p.type === t) || null;
    const types = () => { const set = new Set(forGender().map(p => p.type)); return TYPE_ORDER.filter(t => set.has(t)).concat([...set].filter(t => !TYPE_ORDER.includes(t))); };
    const allColors = () => { const set = []; forGender().forEach(p => p.colors.forEach(cl => { if (!set.includes(cl)) set.push(cl); })); return set; };
    const allSizes = () => { const set = []; forGender().forEach(p => p.sizes.forEach(sz => { if (!set.includes(sz)) set.push(sz); })); return set; };
    const slotColor = sl => sl.color || state.color;
    const slotSize = sl => sl.size || state.size;
    const variantOf = (p, color, size) => p ? p.variants.find(v => (v.color === null || v.color === color) && (v.size === null || v.size === size)) : null;
    const colorAvailable = (p, color) => p.variants.some(v => v.color === color && v.available);
    const sizeAvailable = (p, color, size) => p.variants.some(v => v.color === color && v.size === size && v.available);

    function ensureDefaults() {
      const cols = allColors(), sizes = allSizes();
      if (!cols.includes(state.color)) state.color = cols[0] || null;
      if (!sizes.includes(state.size)) state.size = sizes[0] || null;
      state.slots.forEach(sl => { if (!byType(sl.type)) sl.type = types()[0]; });
    }

    function swatchStyle(p, color) {
      const img = p && p.images && p.images[color];
      return img ? `background-image:url(${img})` : '';
    }

    function render() {
      ensureDefaults();
      // gender
      $$('[data-gender]', el.gender).forEach(b => b.classList.toggle('is-active', b.dataset.gender === state.gender));
      // global colors
      const refP = byType('hoodie') || forGender()[0];
      el.colors.innerHTML = allColors().map(cl => `<button type="button" class="swatch swatch--lg${cl === state.color ? ' is-active' : ''}" data-set-color="${cl}" title="${cl}" aria-label="${cl}" style="${swatchStyle(refP, cl)}"></button>`).join('');
      if (el.colorLabel) el.colorLabel.textContent = state.color || '';
      // global sizes
      el.sizes.innerHTML = allSizes().map(sz => `<button type="button" class="size-btn${sz === state.size ? ' is-active' : ''}" data-set-size="${sz}">${sz}</button>`).join('');
      // slots
      el.slots.innerHTML = state.slots.map((sl, i) => {
        const p = byType(sl.type); if (!p) return '';
        const color = slotColor(sl), size = slotSize(sl);
        const v = variantOf(p, color, size);
        const img = p.images[color] || '';
        return `<div class="sb__slot" data-slot="${i}">
          <div class="sb__slot-head"><span class="eyebrow" style="margin:0">Teil ${i + 1}</span>${state.slots.length > 3 ? `<button type="button" class="icon-btn" data-slot-remove aria-label="Teil entfernen">${icon('close')}</button>` : ''}</div>
          <div class="sb__slot-body">
            <a class="sb__slot-img" href="${p.url}?variant=${v ? v.id : ''}" target="_blank" rel="noopener">${img ? `<img src="${img}" alt="${p.title} ${color}" loading="lazy">` : ''}</a>
            <div class="sb__slot-fields">
              <div class="sb__types">${types().map(t => { const tp = byType(t); return `<button type="button" class="chip${t === sl.type ? ' is-active' : ''}" data-slot-type="${t}">${icon(t)}<span>${tp ? tp.short : t}</span></button>`; }).join('')}</div>
              <div class="sb__slot-title"><b>${p.title}</b> · ${money(v ? v.price : p.price)}</div>
              <div class="swatch-row">${p.colors.map(cl => `<button type="button" class="swatch${cl === color ? ' is-active' : ''}${colorAvailable(p, cl) ? '' : ' is-unavailable'}" data-slot-color="${cl}" title="${cl}" aria-label="${cl}" style="${swatchStyle(p, cl)}"></button>`).join('')}</div>
              <div class="sizes sb__slot-sizes">${p.sizes.map(sz => `<button type="button" class="size-btn${sz === size ? ' is-active' : ''}${sizeAvailable(p, color, sz) ? '' : ' is-soldout'}" data-slot-size="${sz}">${sz}</button>`).join('')}</div>
              ${v && !v.available ? `<p class="fit-hint" style="color:var(--c-sale)">${color} in ${size} ist gerade ausverkauft – wähl eine andere Farbe oder Größe.</p>` : ''}
            </div>
          </div>
        </div>`;
      }).join('');
      if (el.addSlot) el.addSlot.hidden = state.slots.length >= 4;
      // summary
      let sum = 0, ok = true; const rows = [];
      state.slots.forEach(sl => {
        const p = byType(sl.type); const v = variantOf(p, slotColor(sl), slotSize(sl));
        if (!p || !v) { ok = false; return; }
        if (!v.available) ok = false;
        sum += v.price;
        rows.push(`<li><span>${p.short}</span><span class="muted">${slotColor(sl)} · ${slotSize(sl)}</span><span>${money(v.price)}</span></li>`);
      });
      const n = state.slots.length, pct = pctFor(n), setPrice = Math.round(sum * (100 - pct) / 100);
      el.list.innerHTML = rows.join('');
      el.regular.textContent = money(sum);
      el.pct.textContent = pct ? `–${pct} %` : '';
      el.saving.textContent = pct ? `–${money(sum - setPrice)}` : '';
      el.total.textContent = money(setPrice);
      el.note.textContent = n < tiers[0][0] ? `Noch ${tiers[0][0] - n} Teil${tiers[0][0] - n > 1 ? 'e' : ''} bis –${tiers[0][1]} %` : `${n} Teile · –${pct} % Set-Rabatt`;
      if (el.total2) el.total2.textContent = money(setPrice);
      if (el.note2) el.note2.textContent = `${n} Teile · –${pct} %`;
      el.carts.forEach((btn, i) => { btn.disabled = !ok; btn.textContent = ok ? (i === 0 ? `${n} Teile in den Warenkorb – ${money(setPrice)}` : 'In den Warenkorb') : 'Farbe/Größe wählen'; });
    }
    if (el.sticky && el.summary && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => { el.sticky.classList.toggle('is-hidden', entries[0].isIntersecting); }, { threshold: 0.2 }).observe(el.summary);
    }

    root.addEventListener('click', async e => {
      const g = e.target.closest('[data-gender]'); if (g) { state.gender = g.dataset.gender; state.slots.forEach(sl => { sl.color = null; sl.size = null; }); render(); return; }
      const sc = e.target.closest('[data-set-color]'); if (sc) { state.color = sc.dataset.setColor; state.slots.forEach(sl => { sl.color = null; }); render(); return; }
      const ss = e.target.closest('[data-set-size]'); if (ss) { state.size = ss.dataset.setSize; state.slots.forEach(sl => { sl.size = null; }); render(); return; }
      const slotEl = e.target.closest('[data-slot]'); const sl = slotEl ? state.slots[parseInt(slotEl.dataset.slot, 10)] : null;
      if (sl) {
        const t = e.target.closest('[data-slot-type]'); if (t) { sl.type = t.dataset.slotType; render(); return; }
        const cl = e.target.closest('[data-slot-color]'); if (cl) { sl.color = cl.dataset.slotColor; render(); return; }
        const sz = e.target.closest('[data-slot-size]'); if (sz) { sl.size = sz.dataset.slotSize; render(); return; }
        if (e.target.closest('[data-slot-remove]')) { if (state.slots.length > 3) { state.slots.splice(parseInt(slotEl.dataset.slot, 10), 1); render(); } return; }
      }
      if (e.target.closest('[data-sb-add-slot]')) {
        if (state.slots.length < 4) { const used = state.slots.map(x => x.type); const next = types().find(t => !used.includes(t)) || types()[0]; state.slots.push({ type: next, color: null, size: null }); render(); }
        return;
      }
      if (e.target.closest('[data-sb-cart]')) {
        const items = [];
        for (const s of state.slots) { const p = byType(s.type); const v = variantOf(p, slotColor(s), slotSize(s)); if (!v || !v.available) { toast('Bitte verfügbare Farbe/Größe wählen'); return; } items.push({ id: v.id, quantity: 1 }); }
        el.carts.forEach(b => b.classList.add('is-loading'));
        try { await Cart.add(items); } catch (err) { toast(err.message); }
        el.carts.forEach(b => b.classList.remove('is-loading'));
      }
    });
    render();
  });

  document.addEventListener('DOMContentLoaded', () => { if (location.hash === '#cart') Drawer.open('CartDrawer'); });
})();
